<div class="base-container">
    <div bdFxLayoutAlign="space-between center" class="pr-header">
        <div class="pr-left">
            <div class="pr-title">
                Projekte
            </div>
        </div>
        <div class="pr-nav" bdFxLayoutAlign="space-between center">

            <div (click)="openFeedbackLink()" class="pr-feedback">
                <bd-fa name="comment"></bd-fa>
                Ihr Feedback
            </div>

            <button (click)="openProjectsFilterModal()"
                    class="top-filter-btn"
                    type="button"
                    [ngClass]="{'active':hasTopFilterValues()}">
                <bd-fa-button [name]="'sliders'"></bd-fa-button>
                Filter {{ hasTopFilterValues() ? 'bearbeiten' : '' }}
            </button>

            <div bdFxFlex class="pr-btn-reset" [ngClass]="{'active': hasTopFilterValues()}"
                 (click)="resetProjectFilter()">
                <bd-fa-button [name]="'undo'"></bd-fa-button>
            </div>

            <button (click)="onNewProjectBtnClicked()"
                    class="pr-btn-create"
                    type="button">
                Neues Projekt erstellen
            </button>
        </div>
    </div>

    <bd-hr></bd-hr>

    <div class="btn-container clearfix">
        <div class="float-left">
            <button type="button" class="pr-btn" [ngClass]="{'active':isTabActive(myProjectTableIdEnum.OPENED)}"
                    (click)="onTabBtnClicked( myProjectTableIdEnum.OPENED)"
                    type="button">
                Offene Projekte
            </button>
            <button type="button" class="pr-btn" [ngClass]="{'active':isTabActive(myProjectTableIdEnum.CLOSED)}"
                    (click)="onTabBtnClicked( myProjectTableIdEnum.CLOSED)"
                    type="button">
                Abgeschlossene Projekte
            </button>
        </div>

    </div>

    <div bdFxLayoutAlign="space-between start" class="result-description">
        <div bdFxFlex="1 1 80%" bdFxLayoutAlign="start start">
            {{ projectsPaging?.pagination.totalCount }} Ergebnisse
        </div>

        <div bdFxFlex="1 1 20%" class="result-pages" bdFxLayoutAlign="end end">Ergebnisse pro Seite: &nbsp;&nbsp;
            <span (click)="setRecordsPerPage(10)" [ngClass]="{'active': pageSize === 10}">10</span>
            <span>&nbsp;/&nbsp;</span>
            <span (click)="setRecordsPerPage(20)" [ngClass]="{'active': pageSize === 20}"
                  class="inactive">20</span>
            <span>&nbsp;/&nbsp;</span>
            <span (click)="setRecordsPerPage(50)" [ngClass]="{'active': pageSize === 50}">50</span>
        </div>
    </div>

    <div class="no-agreement-info" *ngIf="!isAgreementConfirmed">
        <span class="link" (click)="onRepeatAgreementLinkClicked()">Bitte akzeptieren Sie die Vereinbarung zum Datenschutz</span>
    </div>


    <div class="project-table-container" *ngIf="isTabActive(myProjectTableIdEnum.OPENED)"
         [ngClass]="{'hidden':!isTabActive(myProjectTableIdEnum.OPENED)}">
        <app-filtered-project-table (projectListOrderByParams)="orderByProjectList($event)" [projects]="projects"
                                    [filterChoices]="openedProjectsFilterChoices"
                                    [developId]="'developId OPENED'"
                                    (statusFilterValuesChanged)="onStatusFilterValuesChanged($event)"
                                    (projectsChangedNotification)="onProjectChangedNotification()">

        </app-filtered-project-table>
    </div>
    <div class="project-table-container" *ngIf="isTabActive(myProjectTableIdEnum.CLOSED)"
         [ngClass]="{'hidden':!isTabActive(myProjectTableIdEnum.CLOSED)}">
        <app-filtered-project-table (projectListOrderByParams)="orderByProjectList($event)" [projects]="projects"
                                    [filterChoices]="closedProjectsFilterChoices"
                                    [developId]="'developId CLOSED'"
                                    (statusFilterValuesChanged)="onStatusFilterValuesChanged($event)"
                                    (projectsChangedNotification)="onProjectChangedNotification()">
        </app-filtered-project-table>
    </div>

    <div class="info">
        <img src="./assets/img/icon-internal.svg" class="internal-user-flag-icon"> <span>: von brother erstelltes Projekt</span>
    </div>

    <div class="paging" bdFxLayoutAlign="center center">
        <div class="arrows" [ngClass]="{'active': btnBackActive }"
             (click)="btnBackActive && onClickPage(page - 1, pages)"
             bdFxLayoutAlign="center center">

            <bd-fa [name]="'chevron-left'"></bd-fa>

        </div>
        <div class="pages">&nbsp;Seite {{ page }} von {{ pages.length || 1 }}&nbsp;</div>
        <div class="arrows" [ngClass]="{'active': btnForwardActive }"
             (click)="btnForwardActive && onClickPage(page + 1,pages)"
             bdFxLayoutAlign="center center">

            <bd-fa [name]="'chevron-right'"></bd-fa>
        </div>

    </div>

</div>


<app-multi-contacts-widget></app-multi-contacts-widget>


